export class AuthUser {
  public readonly id: string
  public readonly email: string | null
  public readonly emailVerified: boolean
  public readonly createdAt: Date | null
  public readonly lastSignInTime: Date | null

  constructor(
    id: string,
    email: string | null,
    emailVerified: boolean,
    createdAt: Date | null,
    lastSignInTime: Date | null,
  ) {
    this.id = id
    this.email = email
    this.emailVerified = emailVerified
    this.createdAt = createdAt
    this.lastSignInTime = lastSignInTime
  }
}
